import PropTypes from 'prop-types';
import { Tooltip } from 'react-tooltip';

export const IconWithTooltip = (properties) => {
  const {
    icon,
    iconLabel,
    id,
    tooltipPlacement = 'right',
    desc,
    role = 'img',
  } = properties?? {};
  return (
    <>
      <i
        id={`${id}-icon`}
        className={`${icon} tooltip-icon`}
        data-tooltip-id={`${id}-tooltip`}
        data-tooltip-content={desc}
        aria-label={iconLabel}
        role={role}
        tabIndex={0}
      ></i>
      <Tooltip id={`${id}-tooltip`} place={tooltipPlacement}
        style={{
          width: 'min(300px, 74vw)',
          fontSize: 'min(14.4px, 3vw)',
          zIndex: 1000,
          textAlign: 'center',
        }}
      />
    </>
  );
};

export const InfoIcon = ({ ...props }) => (
  <IconWithTooltip
    id={`info-${props.id}`}
    icon='fa-regular fa-circle-info'
    iconLabel={props.label}
    desc={props.desc}
  />
);

export const NotSupportedWithH265 = (attributes) => {
  const {
    id,
    desc = 'Not supported with H.265 Input',
  } = attributes ?? {};

  return (
    <IconWithTooltip
      id={`info-${id}`}
      icon='fa-solid fa-circle-exclamation warning'
      desc={desc}
    />
  );
};

IconWithTooltip.propTypes = {
  /**
   * Font awesome icon to show the tooltip
   */
  icon: PropTypes.string,
  /**
   * Description of what the icon is referring to
   */
  iconLabel: PropTypes.string,
  /**
   * Unique identifier of the icon
   */
  id: PropTypes.string,
  /**
   * Text shown in the tooltip
   */
  desc: PropTypes.string,
  /**
   * Where the tooltip should show. Default is to the right of the icon
   */
  tooltipPlacement: PropTypes.string,
};

InfoIcon.propTypes = IconWithTooltip.propTypes;